import React, { useEffect, useState } from 'react'
import Footer from '../inc/Footer'
import { Link,useNavigate } from 'react-router-dom'
import axios from 'axios';
import '../inc/GlobalVars';
import { ToastContainer, toast } from 'react-toastify';

function LoginSignup() {
    const navigate = useNavigate();   
const data ={fname:"",lname:"",email:"",phone:"",alternatephone:"",aadhaar:"",pan:"",add1:"",add2:"",password:"",city:"",district:"",state:"",pincode:""}
const [inputData,setInputData] = useState(data);
const [allStates, setAllStates] = useState([]);

const [fname,setFName] = useState('');
const [lname,setLName] = useState('');
const [email,setEmail] = useState('');
const [phone,setPhone] = useState('');
const [alternatePhone,setAlternatePhone] = useState('');
const [aadhaar,setAadhaar] = useState('');
const [pan,setPan] = useState('');
const [add1,setAdd1] = useState('');
const [add2,setAdd2] = useState('');
const [password,setPassword] = useState('');
const [city,setCity] = useState('');
const [district,setDistrict] = useState('');
const [pincode,setPincode] = useState('');
const [cState,setCState] = useState('');

//images of aadhaar and pancard
const [aadhaarFront,setAadhaarFront] = useState('');
const [aadhaarBack,setAadhaarBack] = useState('');
const [pancardImage,setPancardImage] = useState('');


useEffect(() => {
    getAllStates();
  }, []);

function getAllStates()
{
    axios.get(global.apiUrl + "/getAllStates").then(function (response) {
        const statesData = response.data["data"];
        setAllStates(statesData);
      });
}

const handleSubmit = async(e) => {
    e.preventDefault();

    if(fname.length ==0)
    {
        toast.error('First Name Field Cannot Be Empty', {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
            return false;
    }
    if(lname.length ==0)
    {
        toast.error('Last Name Field Cannot Be Empty', {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
            return false;
    }
    if(email.length ==0)
    {
        toast.error('Email Field Cannot Be Empty', {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
            return false;
    }
    if(phone.length ==0)
    {
        toast.error('Mobile Field Cannot Be Empty', {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
            return false;
    }
    if(password.length ==0)
    {
        toast.error('Password Field Cannot Be Empty', {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
            return false;
    }
    if(aadhaar.length ==0)
    {
        toast.error('Aadhaar Field Cannot Be Empty', {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
            return false;
    }
    if(pan.length ==0)
    {
        toast.error('Pan Field Cannot Be Empty', {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
            return false;
    }
    const formData = new FormData();
    formData.append("fname",fname);
    formData.append("lname",lname);
    formData.append("email",email);
    formData.append("phone",phone);
    formData.append("alternatePhone",alternatePhone);
    formData.append("aadhaar",aadhaar);
    formData.append("pan",pan);
    formData.append("add1",add1);
    formData.append("add2",add2);
    formData.append("password",password);
    formData.append("city",city);
    formData.append("state",cState);
    formData.append("pincode",pincode);
    formData.append("district",district);

    formData.append("aadhaarFront",aadhaarFront);
    formData.append("aadhaarBack",aadhaarBack);
    formData.append("pancardImage",pancardImage);




    const response = await axios.post(global.apiUrl+'/userSignup',formData,{
        headers:{'Content-Type': 'multipart/form-data'}}).then(function(response)
        {
            let status= response.data['status'];
            console.log(response);
            if(status == 400)
            {
                toast.error('Email ID/Mobile Number Already Registered', {
                    position: "top-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
            else
            {
                toast.success('Thankyou For Signup. Now Login To Start Bidding!', {
                    position: "top-left",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });

                    setTimeout(()=>{navigate('/')},3000);
            }

        }

        )
}
  return (
    <div>
        <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
        <div className='container'>
            <div className='row'>
            <div className="col-md-12 mb-3  mt-5 text-center">
            <h4 style={{textTransform:"uppercase",textAlign:"center"}}>Signup With <span style={{color:"#149eaf"}}>Indussalvage</span></h4>

            </div>
            </div>
        </div>
        <div className='container mb-3'>
            <div className='row d-flex justify-content-center align-items-center'>
            

            
                <div className='loginBox'>
                    
                    <form>
                        <div className='row mb-2'>
                        <div className='col-md-6 mb-2 input-wrapper'>
                            <label className="labels">First Name<span className='text-danger'>*</span></label>
                            <input type='text' name="fname"  onChange={(e)=>setFName(e.target.value)} className='form-control' placeholder='Enter Your First Name' required />
                        </div>
                        <div className='col-md-6 mb-3 input-wrapper'>
                            <label className="labels">Last Name<span className='text-danger'>*</span></label>
                            <input type='text' name="lname" onChange={(e)=>setLName(e.target.value)} className='form-control' placeholder='Enter Your Last Name' required />
                        </div>
                        </div>
                        <div className='mb-4 input-wrapper'>
                            <label className="labels">Email ID<span className='text-danger'>*</span></label>
                            <input type='email' name="email" onChange={(e)=>setEmail(e.target.value)} className='form-control' placeholder='Enter Your Email ID' required />
                        </div>
                        <div className='row mb-3'>
                        <div className='col-md-6 mb-2 input-wrapper'>
                            <label className="labels">Mobile<span className='text-danger'>*</span></label>
                            <input type='text' name="phone" maxLength="10" onChange={(e)=>setPhone(e.target.value)} className='form-control' placeholder='Enter Phone Number' required />
                        </div>
                        <div className='col-md-6 mb-2 input-wrapper'>
                            <label className="labels">Alternate Number<span className='text-danger'>*</span></label>
                            <input type='text' name="alternatephone" maxLength="10"  onChange={(e)=>setAlternatePhone(e.target.value)} className='form-control' placeholder='Enter Alternate Number' required />
                        </div>
                        </div>
                        <div className='mb-4 input-wrapper'>
                            <label className="labels">Password<span className='text-danger'>*</span></label>
                            <input type='password' name="password"  onChange={(e)=>setPassword(e.target.value)} className='form-control' placeholder='Enter Your Password' required />
                            
                        </div>

                        <div className='row mb-2'>
                        <div className='col-md-10 mb-4  input-wrapper'>
                            <label className="labels">Aadhaar Number<span className='text-danger'>*</span></label>
                            <input type='text' name="aadhaar" onChange={(e)=>setAadhaar(e.target.value)} className='form-control' placeholder='Enter Aadhar Number' required />
                        </div>
                        <div className='col-md-2 mb-2  input-wrapper'>
                            <label className="labels">OTP<span className='text-danger'>*</span></label>
                            <input type='text' className='form-control' placeholder='Enter OTP' required />
                        </div>
                        <div className='col-12 mb-4  input-wrapper'>
                            <label >Aadhaar Front Image<span className='text-danger'>*</span></label>
                            <input type='file' name="aadhaar_front" onChange={(e)=>setAadhaarFront(e.target.files[0])} className='form-control' />
                        </div>
                        <div className='col-12 mb-4 input-wrapper'>
                            <label className="labels">Aadhaar Back Image<span className='text-danger'>*</span></label>
                            <input type='file' name="aadhaar_back" onChange={(e)=>setAadhaarBack(e.target.files[0])} className='form-control' />
                        </div>
                        </div>

                        <div className='row mb-3'>
                        <div className='col-md-12 mb-4  input-wrapper'>
                            <label className="labels">Pancard Number<span className='text-danger'>*</span></label>
                            <input type='text' name="pan"  onChange={(e)=>setPan(e.target.value)} className='form-control' placeholder='Enter Pancard Number' required />
                        </div>
                        
                        <div className='col-12 mb-3 input-wrapper'>
                            <label className="labels">Pancard Image<span className='text-danger'>*</span></label>
                            <input type='file' onChange={(e)=>setPancardImage(e.target.files[0])} className='form-control' />
                        </div>
                       
                        </div>

                        
                        <div className='row mb-4'>
                        <div className='col-md-6 mb-2 input-wrapper'>
                            <label className="labels">Address Line 1<span className='text-danger'>*</span></label>
                            <input type='text' name="add1"  onChange={(e)=>setAdd1(e.target.value)} className='form-control' placeholder='Enter Address' required />
                        </div>
                        
                        <div className='col-md-6 mb-2 input-wrapper'>
                            <label className="labels">Address Line 2<span className='text-danger'>*</span></label>
                            <input type='text' name="add2"  onChange={(e)=>setAdd2(e.target.value)} className='form-control' placeholder='Enter Address' required />
                        </div>
                       
                        </div>

                        <div className='row mb-2'>
                        <div className='col-md-3 mb-2 input-wrapper'>
                            <label className="labels">City<span className='text-danger'>*</span></label>
                            <input type='text' name="city"  onChange={(e)=>setCity(e.target.value)} className='form-control' placeholder='Enter City' required />
                        </div>
                        
                        <div className='col-md-3 mb-2 input-wrapper'>
                            <label className="labels">District<span className='text-danger'>*</span></label>
                            <input type='text' name="district" onChange={(e)=>setDistrict(e.target.value)} className='form-control' placeholder='Enter District' required />
                        </div>
                        <div className='col-md-3 mb-2 input-wrapper'>
                            <label className="labels">State<span className='text-danger'>*</span></label>
                      
                            <input type='text' name="state"  onChange={(e)=>setCState(e.target.value)} className='form-control' placeholder='Enter State' required />
                        </div>
                        
                        <div className='col-md-3 mb-2 input-wrapper'>
                            <label className="labels">Pincode<span className='text-danger'>*</span></label>
                            <input type='text' name="pincode"  onChange={(e)=>setPincode(e.target.value)} className='form-control' placeholder='Enter Pincode' required />
                        </div>
                       
                        </div>

                        <button className='btn btn-primary default-button' onClick={handleSubmit}>Signup Now</button>
                    </form>
               
            </div>
            </div>
        </div>

        <Footer/>
    </div>
  )
}

export default LoginSignup